import React from "react";

import powered_by_gametize_image from "images/core/home/powered-by-gametize.png";
import Link from "components/shared/Link/Link";
import TourPage from "components/shared/Tour/TourPage";
import TourSlider from "./TourSlider";

import localize from "lang/localize";

class AhmaTourPage extends TourPage {
  renderTourSlider() {
    return (
      <TourSlider
        projectId={this.props.projectId}
        slidesLength={this.props.slidesLength}
        completedTour={this.props.completedTour}
        setSlidesLength={this.props.setSlidesLength}
        setCompletedTour={this.props.setCompletedTour}
        handleCloseClick={this.props.handleCloseClick}
        language={this.props.language}
      />
    );
  }

  /* To be added below .tour-cta-container if necessary */
  renderPoweredByGametizeImageContainer() {
    return (
      <div className="pure-g">
        <div className="pure-u-3-8 pure-u-sm-5-12" />
        <div className="pure-u-1-4 pure-u-sm-1-6">
          <a
            href="https://www.gametize.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={powered_by_gametize_image}
              className="imgresponsive"
              alt=""
            />
          </a>
        </div>
        <div className="pure-u-3-8 pure-u-sm-5-12" />
      </div>
    );
  }

  render() {
    return (
      <div className="container verticalpadding relative tour-interface">
        {/* <button
          onClick={e => this.props.handleCloseClick(e)}
          className="close-button-container"
        >
          <i className="fa close-button" aria-hidden="true" />
        </button> */}
        <div className="innerblock flex flex-direction-column justify-content-center">
          <div className="pure-g">
            <div className="pure-u-1 pure-u-sm-1-12" />
            <div className="pure-u-1 pure-u-sm-5-6 bottommargin-30">
              {this.renderTourSlider()}
            </div>
            <div className="pure-u-1 pure-u-sm-1-12" />
          </div>
          <div className="pure-g tour-cta-container">
            <div className="pure-u-1 flex justify-content-center bottommargin-10">
              {
                <Link
                  to={this.props.redirectUrl}
                  className="button cta tour-button"
                  id="tourLinkContinue"
                  onClick={e => this.props.handleCloseClick(e)}
                >
                  {localize("button_quest_continue", this.props.language)}
                </Link>
              }
            </div>
          </div>
          {/* {this.renderPoweredByGametizeImageContainer()} */}
        </div>
      </div>
    );
  }
}

export default AhmaTourPage;
